import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';
import { useNosIdQuery } from './base.hooks';

export const accountServicesQueryOptions = queryOptions({
  queryKey: ['account-services'],
  queryFn: () => api.get('/api/v1/services'),
});

export function useGetAccountServices() {
  return useNosIdQuery(accountServicesQueryOptions);
}
